import { makePrivateRoutes } from 'features/@core'
import { OrderPage } from './features/order'
import { OrdersPage } from './features/orders'

export const ordersRoutes = makePrivateRoutes({
  '/': OrdersPage,
  '/order/:id': OrderPage
})
